module.exports = __webpack_public_path__ + "static/media/bg-lines.dec37f08.png";